import { render, staticRenderFns } from "./Extension.vue?vue&type=template&id=a87df2dc"
import script from "./Extension.vue?vue&type=script&lang=js"
export * from "./Extension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports